import { render, staticRenderFns } from "./entity-related-types-listing.vue?vue&type=template&id=181509ae&"
import script from "./entity-related-types-listing.vue?vue&type=script&lang=js&"
export * from "./entity-related-types-listing.vue?vue&type=script&lang=js&"
import style0 from "./entity-related-types-listing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports